module.exports = __webpack_public_path__ + "img/bind_fb.425eaf04.png";